var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 20,
    height: 20,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2 0h16c1.10320282.0032959 1.9967041.89678955 2 2v12c-.0032959 1.10321045-.89679718 1.9967041-2 2H4l-4 4V2C.003294.89678955.89679718.0032959 2 0zm1.16999817 14H18V2H2v13.16998291L3.16999817 14z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 5,
    y: 7,
    fill: "#000",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 13,
    y: 7,
    fill: "#000",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 9,
    y: 7,
    fill: "#000",
    rx: 0,
    ry: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.da965d873f4f69ba9b53a9d50864d72e.svg";
export { ForwardRef as ReactComponent };